(() => {
  angular
    .module('app.settings')
    .controller('AdformModalController', AdformModal);

  AdformModal.$inject = [
    '$q',
    '$interval',
    'close',
    'provider',
    'CountriesList',
    'allowedMetrics',
    'allowedCountries',
  ];

  function AdformModal(
    $q,
    $interval,
    close,
    provider,
    CountriesList,
    allowedMetrics,
    allowedCountries,
  ) {
    const vm = this;
    vm.integrations = {};


    /* ************************************************************* */
    /* **************************** Tabs *************************** */
    /* ************************************************************* */
    const tabAction = {};

    vm.tabs = [{
      id: 'connect',
      label: 'Connect',
    }, {
      id: 'clients',
      label: 'Clients',
    }, {
      id: 'country',
      label: 'Country',
    }, {
      id: 'trackingDetails',
      label: 'Tracking details',
    }, {
      id: 'complete',
      label: 'Complete',
    }];

    vm.tabActive = -1;
    vm.isTabActive = id => id === vm.tabActive;
    vm.onTabSelect = id => {
      vm.tabActive = id;
      vm.tabs = vm.tabs.map(item => item.id === id ? { ...item, enable: true } : item);
    };

    vm.hasTabError = id => {
      const tab = vm.tabs.find(item => item.id === id);
      if (tab.done && id === 'clients' && !vm.clientsAvailable) {
        return true;
      }

      return false;
    };


    /* ************************************************************* */
    /* *************************** Start *************************** */
    /* ************************************************************* */
    vm.onConnect = () => {
      vm.isProcessBusy = true;

      const adform = window.open(provider.oauth, '_blank');
      const interval = $interval(() => {
        if (!adform.window) {
          $interval.cancel(interval);

          $q.all([
            provider.fetchIntegrations(),
          ])
          .then(response => {
            const { data } = response[0];
            const {
              agencyNames,
              connectedAccountEmail,
            } = data;

            vm.user = connectedAccountEmail;
            vm.account = agencyNames;
            vm.integrations = data;

            vm.onStart();
          })
          .catch(error => {
            const { data, config } = error;
            if (data.errorMessage === 'Integration not found') {
              vm.connectionError = true;
            } else if (config.url.includes('/advertisers')) {
              vm.clientsLoadingError = true;
            }

            console.error(error);
          })
          .finally(() => {
            vm.isProcessBusy = false;
          });
        }
      }, 1000);
    };


    /* ************************************************************* */
    /* *************************** Clients ************************* */
    /* ************************************************************* */
    tabAction['clients'] = () => {
      if (vm.clients.length === 0) {
        vm.loadClients();
      }
    }

    vm.clients = [];
    vm.clientsMenu = [];
    vm.clientsAvailable = true;
    vm.search = '';

    vm.loadClients = () => {
      vm.isProcessBusy = true;

      provider.fetchClients()
        .then(({ data }) => {
          if (data.error?.ex) {
            const ex = JSON.parse(data.error.ex);
            console.error('GET advertisers error:', ex?.errorMessage);
            Notification.showSimpleError(ex?.errorMessage);
            vm.clientsLoadingError = true;

            return false;
          }

          vm.clients = data;

          vm.clientsMenu = [{
            id: 'all',
            label: `All clients (${data.length})`,
          }, {
            id: 'selected',
            label: 'Selected clients only',
          }];
          vm.selectedClients = vm.clientsMenu[0];
          vm.onSelectAllClients(true);
        })
        .catch(error => {
          console.error(error.statusText);
          Notification.showSimpleError(error.statusText);
        })
        .finally(() => {
          vm.isProcessBusy = false;
        });
    };

    const onEditClients = () => {
      const selectedClients = vm.clients.filter(item => item.isSelected).map(item => item.name);
      vm.clientsAvailable = selectedClients.length !== 0;
    };

    const getAdvertiserIds = () => (
      vm.clients
        .filter(item => vm.selectedClients.id === 'all' || item.isSelected)
        .map(item => item.id)
    );

    const checkAdvertisersUsage = () => {
      vm.isProcessBusy = true;

      provider.updateIntegrations({
        advertiserIds: getAdvertiserIds(),
      })
      .then(() => {
        vm.clientsAlreadyUsed = false;

        onEditClients();
      })
      .catch(error => {
        console.error(error);
        if (error.status === 400) {
          const message = /\[(.*?)\]/.exec(error.data.message);
          const ids = message ? message[1].split(',') : [];
          const clients = vm.clients.filter(({ id }) => ids.includes(id.toString()));

          vm.clientsAlreadyUsed = clients.map(({ name }) => name);
          vm.clientsAvailable = false;
        }
      })
      .finally(() => {
        vm.isProcessBusy = false;
      });
    };

    vm.onSelectAllClients = select => {
      angular.forEach(vm.clients, client => client.isSelected = !!select);
      onEditClients();
    };

    vm.onCheckClient = client => {
      client.isSelected = !client.isSelected;
      onEditClients();
    };

    vm.onSelectClients = item => {
      vm.selectedClients = item;
      if (item.id === 'all') {
        vm.onSelectAllClients(true);
      } else {
        onEditClients();
      }
    };

    vm.onShowSearch = () => vm.searchVisible = !vm.searchVisible;
    vm.onClearSearch = () => {
      vm.searchVisible = false;
      vm.search = '';
    };


    /* ************************************************************* */
    /* *************************** Country ************************* */
    /* ************************************************************* */
    tabAction['country'] = () => {
      const { country } = vm.integrations;
      vm.currentCountry = vm.countries.find(item => item.code === (country || 'DK'));

      if (!vm.isProcessBusy) {
        checkAdvertisersUsage();
      }
    }

    vm.countries = CountriesList.filter(item => allowedCountries.includes(item.code));
    vm.onSelectCountry = country => vm.currentCountry = country;


    /* ************************************************************* */
    /* ********************** Tracking details ********************* */
    /* ************************************************************* */
    vm.medias = [];
    tabAction['trackingDetails'] = () => {
      const isSelected = key => {
        const { qualityMetrics } = vm.integrations;
        return qualityMetrics && qualityMetrics.includes(key);
      };

      vm.metrics = allowedMetrics.map(item => ({
        ...item,
        checked: isSelected(item.key),
      }));

      if (vm.medias.length === 0) {
        loadMedias();
      }
    };

    vm.onCheckMetric = metric => {
      const activeMetric = vm.metrics.find(item => item.name === metric.name);
      activeMetric.checked = !activeMetric.checked;
    };

    vm.setupVideoFunnelEvents = true;
    vm.showVideoFunnelMessage = false;
    vm.onSetupVideoFunnelEvents = () => {
      vm.setupVideoFunnelEvents = !vm.setupVideoFunnelEvents;
      vm.showVideoFunnelMessage = !vm.setupVideoFunnelEvents;
    };



    /* ************************************************************* */
    /* *************************** Medias ************************** */
    /* ************************************************************* */
    vm.mediasLoading = true;
    function loadMedias() {
      provider.fetchMedias()
        .then(({ data }) => {
          if (data.error?.ex) {
            const ex = JSON.parse(data.error.ex);
            console.error('GET medias error:', ex?.errorMessage || data.error.message);
            Notification.showSimpleError(ex?.errorMessage || data.error.message);
            vm.mediasLoadingError = ex?.errorMessage || data.error.message;

            return false;
          }

          vm.mediasLoadingError = false;
          vm.medias = data.map(item => ({
            ...item,
            blocked: false,
          }));
        })
        .finally(() => {
          vm.mediasLoading = false;
        });
    }

    const getBlockedMediaIds = () => vm.medias.filter(({ blocked }) => blocked).map(({ id }) => id).sort();
    const updateActionsDisabled = () => {
      vm.mediaAddSelectedEnabled = vm.medias.some(item => item.checked && !item.blocked);
      vm.mediaRemoveSelectedEnabled = vm.medias.some(item => item.checked && item.blocked);
    };

    vm.handleCheckMedia = ({ id }) => {
      const media = vm.medias.find(item => item.id === id);
      media.checked = !media.checked;

      updateActionsDisabled();
    };

    vm.handleAddSelected = () => {
      vm.filteredMedias.forEach(item => {
        if (item.checked) {
          item.blocked = true;
        }
      });

      updateActionsDisabled();
    };

    vm.handleRemoveSelected = () => {
      vm.filteredBlockedMedias.forEach(item => {
        if (item.checked) {
          item.blocked = false;
        }
      });

      updateActionsDisabled();
    };

    vm.handleShowMediaSearch = () => vm.mediaSearchVisible = !vm.mediaSearchVisible;
    vm.handleClearMediaSearch = () => {
      vm.mediaSearchVisible = false;
      vm.mediaSearch = '';
    };
    // tabAction['trackingDetails'](); // FIXME: remove


    /* ************************************************************* */
    /* *************************** Actions ************************* */
    /* ************************************************************* */
    vm.onStart = () => vm.tabActive = 'connect';
    vm.onFinish = () => close(true, 0);
    vm.onClose = () => {
      if (vm.tabActive === 'complete') {
        vm.onFinish();
      } else {
        close(false, 0);
      }
    };

    vm.onBack = id => vm.onTabSelect(id);
    vm.onNext = id => {
      vm.tabs = vm.tabs.map(item => (
        item.id === vm.tabActive ? {
          ...item,
          enable: true,
          done: true,
        } : item
      ));
      vm.onTabSelect(id);

      if (tabAction[id]) {
        tabAction[id]();
      }
    };

    vm.onEnable = next => {
      vm.isProcessBusy = true;
      provider.updateIntegrations({
        country: vm.currentCountry.code,
        advertiserIds: getAdvertiserIds(),
        qualityMetrics: vm.metrics.filter(item => item.checked).map(item => item.key),
        setupVideoFunnelEvents: vm.setupVideoFunnelEvents,
        blockedMediaIds: getBlockedMediaIds(),
      })
      .then(() => {
        provider.activateIntegrations()
          .then(() => {
            vm.onNext(next);
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            vm.isProcessBusy = false;
          });
      });
    };
  }
})();
